import(/* webpackMode: "eager", webpackExports: ["ArticleDisclosure","CryptoDisclosure","AffiliateDisclosure"] */ "/app/src/app/_components/Article/ArticleHeader/ArticleDisclosure.tsx");
